import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";

import * as apiUrl from "../../apiUrl";

function HomeAbout() {
  const [HomeAbout, setHomeAbout] = useState([]);

  useEffect(() => {
    const fetchHomeAbout = async () => {
      try {
        const response = await fetch(apiUrl.apiUrl + `/api/home/about-section`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeAbout(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeAbout();
  }, []);

  const sectionTitle =
    HomeAbout && HomeAbout.section_title ? HomeAbout.section_title : "";

  return (
    <section className="home-about-sec">
      <Container fluid className="home-about-container">
        <Row className="banner-text-center head-div">
          <Col md={6}>
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {" "}
                {parse(sectionTitle)}
              </h2>
              <h1 className="common-para" data-aos="fade-up">
                Marquis, Real Estate Developer in Dubai, UAE
              </h1>
            </div>
          </Col>
        </Row>

        <Row className="flex-center about-img-row">
          <Col md={5}>
            <div className="about-img-div">
              <img
                src={apiUrl.apiUrl + `/` + HomeAbout.about_left_image}
                className="img-fluid about-right-img"
                alt="Marquis Property Developer"
                data-aos="fade-right"
              />
            </div>
          </Col>
          <Col md={7}>
            <div className="about-img-div">
              <img
                src={apiUrl.apiUrl + `/` + HomeAbout.about_right_image}
                className="img-fluid"
                alt="Marquis Real Estate Developer"
                data-aos="fade-left"
              />
            </div>
          </Col>
        </Row>
        <Row className="flex-center about-content-row text-center">
          <Col md={8}>
            <div className="about-content-div">
              <p className="common-para" data-aos="fade-up">
                {HomeAbout.section_description}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HomeAbout;
